import { render, staticRenderFns } from "./KetcherDialog.vue?vue&type=template&id=19f35ca5"
import script from "./KetcherDialog.vue?vue&type=script&lang=js"
export * from "./KetcherDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports